import moment from 'moment';
export default {
	totalSize_: state => {
		const { totalSize } = state.pagingInfo;
		return totalSize;
	},

	pageUnit_: state => {
		const { pageUnit } = state.pagingInfo;
		return pageUnit;
	},
	getStartAplcDd_: ({ searchParams }) => searchParams.startAplcDd,
	getEndAplcDd_: ({ searchParams }) => searchParams.endAplcDd,
	getStartDcsnDd_: ({ searchParams }) => searchParams.startDcsnDd,
	getEndDcsnDd_: ({ searchParams }) => searchParams.endDcsnDd,

	resultFileList_({ fileList }) {
		return fileList;
	},
	//상태값
	getIsSaveFlag_({ isSaveFlag }) {
		return isSaveFlag;
	}
};
